mutation DeleteInlineComment($commentIdToDelete: ID!) {
  deleteComment(commentIdToDelete: $commentIdToDelete)
}
